import React from 'react';

/**
 * The "grösste Hochzeitsplattform" trust banner.
 *
 * Ported verbatim from toastably-web/partials/banner-claim.html. Identical on every
 * landing page, which is why it is a component rather than per-page data.
 */
const ClaimBanner = () => (
  <section className="section-claim" aria-labelledby="claim-title">
    <div className="container claim-inner">
      <svg className="claim-laurel" viewBox="0 0 44 96" aria-hidden="true" focusable="false">
        <defs>
          <path id="claim-leaf" d="M0 0 Q6.2 -4.3 13 0 Q6.2 4.3 0 0 Z" />
        </defs>
        <path
          d="M36 92 C 16 72, 10 44, 22 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        <g fill="currentColor">
          <use href="#claim-leaf" transform="translate(32.6 88.3) rotate(-176.1) scale(0.98)" />
          <use href="#claim-leaf" transform="translate(32.6 88.3) rotate(-86.1) scale(0.98)" />
          <use href="#claim-leaf" transform="translate(26.1 79.7) rotate(-167.2) scale(0.92)" />
          <use href="#claim-leaf" transform="translate(26.1 79.7) rotate(-77.2) scale(0.92)" />
          <use href="#claim-leaf" transform="translate(21.2 70.3) rotate(-157.8) scale(0.87)" />
          <use href="#claim-leaf" transform="translate(21.2 70.3) rotate(-67.8) scale(0.87)" />
          <use href="#claim-leaf" transform="translate(17.9 60) rotate(-148.4) scale(0.82)" />
          <use href="#claim-leaf" transform="translate(17.9 60) rotate(-58.4) scale(0.82)" />
          <use href="#claim-leaf" transform="translate(16.1 48.7) rotate(-139.6) scale(0.77)" />
          <use href="#claim-leaf" transform="translate(16.1 48.7) rotate(-49.6) scale(0.77)" />
          <use href="#claim-leaf" transform="translate(16 36.6) rotate(-131.6) scale(0.72)" />
          <use href="#claim-leaf" transform="translate(16 36.6) rotate(-41.6) scale(0.72)" />
          <use href="#claim-leaf" transform="translate(17.6 23.5) rotate(-124.7) scale(0.66)" />
          <use href="#claim-leaf" transform="translate(17.6 23.5) rotate(-34.7) scale(0.66)" />
          <use href="#claim-leaf" transform="translate(20 12.7) rotate(-75) scale(0.62)" />
        </g>
      </svg>
      <div className="claim-body">
        <h2 id="claim-title">
          Die grösste Hochzeitsplattform der&nbsp;Schweiz<sup className="claim-ref">*</sup>
        </h2>
        <div className="claim-divider" aria-hidden="true">
          <span className="claim-heart">&#9829;</span>
        </div>
        <p className="claim-foot">
          *Gemessen an der Anzahl verf&uuml;gbarer Hochzeitsangebote/Listings auf der Plattform.
        </p>
        <p className="claim-stand">Stand: Juli 2026</p>
      </div>
      <svg
        className="claim-laurel claim-laurel-right"
        viewBox="0 0 44 96"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <path id="claim-leaf-right" d="M0 0 Q6.2 -4.3 13 0 Q6.2 4.3 0 0 Z" />
        </defs>
        <path
          d="M36 92 C 16 72, 10 44, 22 6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
        <g fill="currentColor">
          <use
            href="#claim-leaf-right"
            transform="translate(32.6 88.3) rotate(-176.1) scale(0.98)"
          />
          <use
            href="#claim-leaf-right"
            transform="translate(32.6 88.3) rotate(-86.1) scale(0.98)"
          />
          <use
            href="#claim-leaf-right"
            transform="translate(26.1 79.7) rotate(-167.2) scale(0.92)"
          />
          <use
            href="#claim-leaf-right"
            transform="translate(26.1 79.7) rotate(-77.2) scale(0.92)"
          />
          <use
            href="#claim-leaf-right"
            transform="translate(21.2 70.3) rotate(-157.8) scale(0.87)"
          />
          <use
            href="#claim-leaf-right"
            transform="translate(21.2 70.3) rotate(-67.8) scale(0.87)"
          />
          <use href="#claim-leaf-right" transform="translate(17.9 60) rotate(-148.4) scale(0.82)" />
          <use href="#claim-leaf-right" transform="translate(17.9 60) rotate(-58.4) scale(0.82)" />
          <use
            href="#claim-leaf-right"
            transform="translate(16.1 48.7) rotate(-139.6) scale(0.77)"
          />
          <use
            href="#claim-leaf-right"
            transform="translate(16.1 48.7) rotate(-49.6) scale(0.77)"
          />
          <use href="#claim-leaf-right" transform="translate(16 36.6) rotate(-131.6) scale(0.72)" />
          <use href="#claim-leaf-right" transform="translate(16 36.6) rotate(-41.6) scale(0.72)" />
          <use
            href="#claim-leaf-right"
            transform="translate(17.6 23.5) rotate(-124.7) scale(0.66)"
          />
          <use
            href="#claim-leaf-right"
            transform="translate(17.6 23.5) rotate(-34.7) scale(0.66)"
          />
          <use href="#claim-leaf-right" transform="translate(20 12.7) rotate(-75) scale(0.62)" />
        </g>
      </svg>
    </div>
  </section>
);

export default ClaimBanner;
